import React from 'react'
import classes from "./IconButton.module.scss"

interface IconButtonProps {
  type?: "button" | "submit" | "reset" | undefined
  className?: string
  size?: "lg" | "md" | "sm" | undefined
  color?: "white" | "transparent" | "light-blue" | undefined
  icon?: "power" | "bell" | "trash" | "filter" | undefined
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  redMark?: boolean
}

export default function IconButton({type = "button", className, color, onClick, icon, size = "md", redMark = false}: IconButtonProps) {

  const cls: string[] = [classes.button]

  if (className) {
    cls.push(className)
  }

  if (icon) {
    cls.push(classes[icon])
  } else {
    cls.push(classes.default)
  }

  if (size) {
    cls.push(classes[`size_${size}`])
  }

  if (color) {
    cls.push(classes[color])
  }

  if (redMark) {
    cls.push(classes.red_mark)
  }

  return(
    <button
      className={cls.join(" ")}
      type={type}
      onClick={onClick}
    >
      <span className={classes.icon}></span>
    </button>
  )
}